import { FC, useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import CategoryPromoSlides from './CategoryPromoSlides';
import CategoryPromoSpotSliderButton from './CategoryPromoSpotSliderButton';
import { CategoryPromoCarouselProps, CategoryPromoSlidesGroup } from './categoryPromoSpotTypes';

const CategoryPromoSlider: FC<CategoryPromoCarouselProps> = ({ items }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    watchFocus: false,
    containScroll: 'keepSnaps',
  });
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = items.reduce<CategoryPromoSlidesGroup[]>((acc, item, index) => {
    const slideIndex = Math.floor(index / 3);
    if (!acc[slideIndex]) {
      acc[slideIndex] = { id: '', items: [] };
    }
    acc[slideIndex].items.push(item);

    acc[slideIndex].id = acc[slideIndex].items.map((item) => item.id).join('-');

    return acc;
  }, []);

  const scrollPrev = useCallback(() => {
    if (emblaApi && emblaApi.canScrollPrev()) {
      emblaApi.scrollPrev();
    }
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi && emblaApi.canScrollNext()) {
      emblaApi.scrollNext();
    }
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', onSelect);
    }
  }, [emblaApi, onSelect]);

  return (
    <div className="container relative flex w-full flex-col self-center py-0">
      <div className="hidden sm:block">
        <CategoryPromoSpotSliderButton
          direction="left"
          onClick={scrollPrev}
          disabled={!emblaApi?.canScrollPrev()}
        />
        <CategoryPromoSpotSliderButton
          direction="right"
          onClick={scrollNext}
          disabled={!emblaApi?.canScrollNext()}
        />
      </div>

      <div ref={emblaRef} className="hidden sm:block">
        <div className="flex gap-4">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`min-w-full ${activeIndex === index ? 'opacity-100' : 'opacity-30'}`}
            >
              <CategoryPromoSlides isActive={activeIndex === index} items={slide.items} />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-4 sm:hidden">
        {slides.map((slide, index) => (
          <div key={slide.id} className={`min-w-full`}>
            <CategoryPromoSlides isActive={activeIndex === index} items={slide.items} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryPromoSlider;
